import { BaseModel } from "./base-model";

export class PaymentTargetModel extends BaseModel {

  active: boolean = true
  name: string = ""

  constructor(params: any = null) {
    super(params)
    this.copyFromObject(params)
  }

  static override newModel(object: any = null) {
    return new PaymentTargetModel(object)
  }
}
